import { render, staticRenderFns } from "./UOM.vue?vue&type=template&id=6fa15848&scoped=true"
import script from "./UOM.vue?vue&type=script&lang=js"
export * from "./UOM.vue?vue&type=script&lang=js"
import style0 from "./UOM.vue?vue&type=style&index=0&id=6fa15848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa15848",
  null
  
)

export default component.exports